import { AiOutlineCamera, AiOutlinePlus } from "react-icons/ai";
import { FaAngleDown, FaRegCalendarAlt } from "react-icons/fa";
import { IoMdRefresh } from "react-icons/io";
import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import CreateExtraFeaturedOptions from "../CreateAuctionListingForm/CreateExtraFeaturedOptions";
import Button from "../Shared/Button/Button";

const OtherBuylistingCustomForm = () => {
  return (
    <div>
      <div>
        <h3 className="mt-8 font-pop text-3xl font-semibold text-textColor">
          Choose your Selling format
        </h3>
        <div>
          <div>
            <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
              Listing Type
            </h5>
            <div className="mt-4 flex items-center">
              <input
                className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                type="text"
                placeholder="Buy Now"
              />
              <div className="bg-primary py-[21px] px-6 text-white">
                <FaAngleDown className="h-6 w-6" />
              </div>
            </div>
          </div>
          <div className="flex items-center gap-x-10">
            <div className="relative">
              <h5 className="mt-8 mb-4 font-pop text-xl font-medium text-black text-opacity-50">
                Start Date
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-6 outline-none"
                type="text"
                placeholder="2/10/2022 21:20"
              />
              <FaRegCalendarAlt className="absolute top-[101px] right-5 text-primary" />
            </div>
            <div className="relative">
              <h5 className="mt-8 mb-4 font-pop text-xl font-medium text-black text-opacity-50">
                End Date
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-6 outline-none"
                type="text"
                placeholder="2/10/2022 21:20"
              />
              <FaRegCalendarAlt className="absolute top-[101px] right-5 text-primary" />
            </div>
          </div>
          <div className="flex items-center gap-x-10">
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Quantity Available
              </h5>
              <div className="mt-4 flex items-center">
                <p className="border border-solid border-black border-opacity-50 py-[18px] px-7 font-pop text-xl font-medium text-black">
                  R
                </p>
                <input
                  className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                  type="text"
                  placeholder="0.00"
                />
              </div>
            </div>
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Buy Now Price
              </h5>
              <div className="mt-4 flex items-center">
                <p className="border border-solid border-black border-opacity-50 py-[18px] px-7 font-pop text-xl font-medium text-black">
                  R
                </p>
                <input
                  className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                  type="text"
                  placeholder="0.00"
                />
              </div>
            </div>
          </div>
          <div className="flex items-center gap-x-10">
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Estimate Market Value
              </h5>
              <div className="mt-4 flex items-center">
                <p className="border border-solid border-black border-opacity-50 py-[18px] px-7 font-pop text-xl font-medium text-black">
                  R
                </p>
                <input
                  className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                  type="text"
                  placeholder="0.00"
                />
              </div>
            </div>
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Item Condition
              </h5>
              <div className="mt-4 flex items-center">
                <input
                  className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                  type="text"
                  placeholder="Buy Now"
                />
                <div className="bg-primary py-[21px] px-6 text-white">
                  <FaAngleDown className="h-6 w-6" />
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-x-10">
            <div className="relative">
              <h5 className="text-sx mt-8 mb-4 font-pop font-medium text-black text-opacity-50">
                This feature will auto relist your listing
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-12 outline-none"
                type="text"
                placeholder="Auto Relist"
              />
              <MdCheckBoxOutlineBlank className="absolute top-[98px] left-5 text-[#C4C4C4]" />
            </div>
            <div className="relative">
              <input
                className="mt-[72px] w-[442px] border border-solid border-inputBorder py-5 px-12 outline-none"
                type="text"
                placeholder="Manual Relist"
              />
              <MdCheckBoxOutlineBlank className="absolute top-[98px] left-5 bg-primary text-primary" />
            </div>
          </div>
          <div className="flex justify-end">
            <p className="font-regular mr-[95px] mt-2 w-[439px] font-pop text-xs text-black text-opacity-50 ">
              You can edit your item before putting it back on action.Your
              listing will appear in your user account if an auction ends and
              your item .
            </p>
          </div>
          <div className="flex items-center gap-x-10">
            <div className="relative">
              <h5 className="text-sx mt-8 mb-4 font-pop font-medium text-black text-opacity-50">
                (Fees Apply)
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-12 outline-none"
                type="text"
                placeholder="Include enhancements"
              />
              <MdCheckBoxOutlineBlank className="absolute top-[98px] left-5 text-[#C4C4C4]" />
            </div>
            <div className="relative">
              <h5 className="text-sx mt-8 mb-4 font-pop font-medium text-black text-opacity-50">
                Allow buyers to send you offers
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-12 outline-none"
                type="text"
                placeholder="Allow Offers"
              />
              <MdCheckBoxOutlineBlank className="absolute top-[98px] left-5 bg-primary text-primary" />
            </div>
          </div>
          <div className="flex items-center gap-x-10">
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Return offers
              </h5>
              <div className="mt-4 flex items-center">
                <input
                  className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                  type="text"
                  placeholder="No Guarantee"
                />
                <div className="bg-primary py-[21px] px-6 text-white">
                  <FaAngleDown className="h-6 w-6" />
                </div>
              </div>
            </div>
            <div>
              <h5 className="mt-8 mb-4 font-pop text-xl font-medium text-black text-opacity-50">
                Condition of Guarantee
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-6 outline-none"
                type="text"
                placeholder=""
              />
            </div>
          </div>
          <div className="flex items-center gap-x-10">
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Warranty
              </h5>
              <div className="mt-4 flex items-center">
                <input
                  className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                  type="text"
                  placeholder="No Warranty"
                />
                <div className="bg-primary py-[21px] px-6 text-white">
                  <FaAngleDown className="h-6 w-6" />
                </div>
              </div>
            </div>
            <div>
              <h5 className="mt-8 mb-4 font-pop text-xl font-medium text-black text-opacity-50">
                Condition of Warranty
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-6 outline-none"
                type="text"
                placeholder=""
              />
            </div>
          </div>
          <div className="flex items-center gap-x-10">
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Prefered Payment Method
              </h5>
              <div className="mt-4 flex items-center">
                <input
                  className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                  type="text"
                  placeholder="Bank transfer, cash"
                />
                <div className="bg-primary py-[21px] px-6 text-white">
                  <FaAngleDown className="h-6 w-6" />
                </div>
              </div>
            </div>
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Shipping
              </h5>
              <div className="mt-4 flex items-center">
                <input
                  className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                  type="text"
                  placeholder="postnet to postnet"
                />
                <div className="bg-primary py-[21px] px-6 text-white">
                  <FaAngleDown className="h-6 w-6" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h3 className="mt-8 font-pop text-xl font-semibold text-textColor">
            Select/add your listing’s details here
          </h3>
          <div>
            <div className="flex items-center gap-x-10">
              <div>
                <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                  Seller Type
                </h5>
                <div className="mt-4 flex items-center">
                  <input
                    className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                    type="text"
                    placeholder="Enter here"
                  />
                  <div className="bg-primary py-[21px] px-6 text-white">
                    <FaAngleDown className="h-6 w-6" />
                  </div>
                </div>
              </div>
              <div>
                <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                  Condition
                </h5>
                <div className="mt-4 flex items-center">
                  <input
                    className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                    type="text"
                    placeholder="Enter Here"
                  />
                  <div className="bg-primary py-[21px] px-6 text-white">
                    <FaAngleDown className="h-6 w-6" />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-x-10">
              <div>
                <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                  Brand/Make
                </h5>
                <div className="mt-4 flex items-center">
                  <input
                    className="w-[370px] border border-solid border-inputBorder py-5 px-6 outline-none"
                    type="text"
                    placeholder="Enter here"
                  />
                  <div className="bg-primary py-[21px] px-6 text-white">
                    <FaAngleDown className="h-6 w-6" />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Description
              </h5>
              <textarea
                className="mt-4 h-[190px] w-[934px] border border-solid border-inputBorder py-6 px-6 outline-none"
                rows=""
                type="text"
                cols=""
                placeholder="Type Here....."
              ></textarea>
            </div>
            <div>
              <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
                Add Photos
              </h5>
              <div className="mt-4 w-[934px] border border-solid border-inputBorder">
                <h5 className="mt-6 ml-6 mb-4 font-pop text-xl font-medium text-black text-opacity-50">
                  Main Photo
                </h5>
                <div className="ml-6 flex flex-wrap items-center gap-x-8">
                  <div className="mb-8 h-[178px] w-[150px]">
                    <img
                      src="assets/images/auction_listing/carimg.png"
                      alt="carimg"
                    />
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="mb-8 h-[178px] w-[150px]">
                    <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
                      <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
                      <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="mb-8 h-[178px] w-[150px]">
                    <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
                      <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
                      <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="mb-8 h-[178px] w-[150px]">
                    <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
                      <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
                      <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="mb-8 h-[178px] w-[150px]">
                    <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
                      <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
                      <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="mb-8 h-[178px] w-[150px]">
                    <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
                      <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
                      <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="mb-8 h-[178px] w-[150px]">
                    <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
                      <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
                      <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="mb-8 h-[178px] w-[150px]">
                    <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
                      <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
                      <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="mb-8 h-[178px] w-[150px]">
                    <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
                      <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
                      <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="mb-8 h-[178px] w-[150px]">
                    <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
                      <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
                      <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
                    </div>
                    <div className="mt-2 flex items-center justify-center gap-x-6">
                      <RiDeleteBinLine className="h-5 w-5" />
                      <IoMdRefresh className="h-5 w-5" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex items-center gap-x-10">
            <div>
              <h5 className="mt-8 mb-4 font-pop text-xl font-medium text-black text-opacity-50">
                Item Location(Province)
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-6 outline-none"
                type="text"
                placeholder="Gauteng"
              />
            </div>
            <div>
              <h5 className="mt-8 mb-4 font-pop text-xl font-medium text-black text-opacity-50">
                City
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-6 outline-none"
                type="text"
                placeholder="Elardus Park"
              />
            </div>
          </div>
        </div>
        <div>
          <div className="flex items-center gap-x-10">
            <div>
              <h5 className="mt-8 mb-4 font-pop text-xl font-medium text-black text-opacity-50">
                Username to Display
              </h5>
              <input
                className="w-[442px] border border-solid border-inputBorder py-5 px-6 outline-none"
                type="text"
                placeholder="Paul1956"
              />
            </div>
          </div>
        </div>
        <div>
          <div>
            <h5 className="mt-8 font-pop text-xl font-medium text-black text-opacity-50">
              Select Extra Featured Options
            </h5>
            <CreateExtraFeaturedOptions />
            <div className="w-[934px]">
              <div className="mt-10 mb-16 flex items-center justify-end gap-3">
                <span className="font-pop text-[25px] font-medium text-black opacity-50">
                  Total Payable
                </span>
                <span className="inline-block border border-priceBorder py-[18px] px-11 font-pop text-[25px] font-medium text-primary">
                  R25.00
                </span>
              </div>
              <div className="mb-[90px] flex justify-between gap-4 px-2.5">
                <Button text={"Delete"} variant="red" className="text-2xl" />
                <Button
                  text={"Preview Listing"}
                  variant="primary"
                  className="text-2xl"
                />
                <Button
                  text={"Agree and Submit"}
                  variant="secondary"
                  className="text-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherBuylistingCustomForm;
